import type { ZodSchema } from 'zod';

export const getZodSchemaValidationError = <T>(
  result: T | null,
  schema: ZodSchema
) => {
  if (!result) {
    return null;
  }
  const parsedResponse = schema.safeParse(result);

  if (parsedResponse.success) {
    return null;
  }

  return parsedResponse.error;
};
